import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEREQUESTS } from "../../../../utils/constants";
import { PRInterface } from "../../../../models/ProcurementModule/PurchaseRequest";

interface UpdatePRContext {
  previousPR: PRInterface[];
}

interface UpdateDocumentUrlInput {
  id: string;
  documentUrl: string;
}

const useAddDocGenPR = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateDocumentUrlInput, UpdatePRContext>({
    // No mutationFn needed if there's no server call
    mutationFn: async () => {
      return; // optional noop
    },

    onMutate: async ({ id, documentUrl }) => {
      await queryClient.cancelQueries({
        queryKey: [CACHE_KEY_PURCHASEREQUESTS, page, pageSize],
      });

      const previousRFQ =
        queryClient.getQueryData<PRInterface[]>([
          CACHE_KEY_PURCHASEREQUESTS,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<PRInterface[]>(
        [CACHE_KEY_PURCHASEREQUESTS, page, pageSize],
        (data = []) =>
          data.map((item) => (item.id === id ? { ...item, documentUrl } : item))
      );

      return { previousPR: previousRFQ };
    },

    onError: (_error, _variables, context) => {
      if (!context) return;

      queryClient.setQueryData<PRInterface[]>(
        [CACHE_KEY_PURCHASEREQUESTS, page, pageSize],
        context.previousPR
      );
    },
  });
};

export default useAddDocGenPR;
